import React, { useEffect } from 'react';
import '../styles/ImpactNumbers.css';

function ImpactNumbers() {
  useEffect(() => {
    const titleElement = document.querySelector('.impact-title');
    if (titleElement) {
      titleElement.classList.add('animate-in');
    }
  }, []);

  return (
    <section className="impact-section">
      <h2 className="impact-title">
        <span className="impact-numbers">Our Impact</span> in Numbers
      </h2>
      <div className="impact-image-container">
        <img 
          src="/assets/images/impact_image2.png" 
          alt="Biking impact" 
          className="impact-background-image" 
        />
      </div>
    </section>
  );
}

export default ImpactNumbers;